import React from "react"
import Layout from "../components/layout"
import { useStaticQuery, graphql } from "gatsby"
import SEO from "../components/seo"
import EventTag from "../components/event-tag"
import EventFields from "../components/event-fields"
import Img from "gatsby-image"
import "./events.scss"

// Function to parse Markdown links and convert them to HTML with inline style
const parseMarkdownLinks = (text) => {
  if (!text) return text
  
  // Simple regex to match Markdown links: [text](url)
  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g
  const parts = []
  let lastIndex = 0
  let match
  
  while ((match = linkRegex.exec(text)) !== null) {
    // Add text before the link
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index))
    }
    
    // Add the link with inline style
    parts.push(
      `<a href=\"${match[2]}\" target=\"_blank\" rel=\"noopener noreferrer\" style=\"color:#000;text-decoration:underline;\">${match[1]}</a>`
    )
    
    lastIndex = match.index + match[0].length
  }
  
  // Add remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }
  
  return parts.join('')
}

const EventsPage = () => {
  const queryResult = useStaticQuery(graphql`
    query EventPageQuery {
      events: allMarkdownRemark(
        sort: { fields: frontmatter___startDate, order: DESC }
        filter: { fields: { sourceInstanceName: { eq: "events" } } }
      ) {
        edges {
          node {
            id
            frontmatter {
              type
              title
              location
              startDate
              endDate
              images
            }
          }
        }
      }
      photos: allFile(filter: { sourceInstanceName: { eq: "photos" } }) {
        nodes {
          childImageSharp {
            fixed(width: 360, height: 270) {
              ...GatsbyImageSharpFixed
              originalName
            }
          }
          id
        }
      }
    }
  `)
  const events = queryResult.events.edges.map((x) => ({ ...x.node.frontmatter, id: x.node.id }))
  const photos = new Map(
    queryResult.photos.nodes.map((x) => [x.childImageSharp.fixed.originalName, x])
  )
  for (const event of events) {
    event.images = (event.images || [])
      .map((fileName) => {
        const image = photos.get(fileName)
        return image === undefined ? null : { key: image.id, fixed: image.childImageSharp.fixed }
      })
      .filter((x) => x !== null)
  }
  return (
    <Layout>
      <SEO title="Events" />
      {events.map((event) => (
        <div className="event-card" id={event.id} key={event.id}>
          <h2 className="title">
            <EventTag type={event.type}>{event.type}</EventTag>
            <span dangerouslySetInnerHTML={{ __html: parseMarkdownLinks(event.title) }} />
          </h2>
          <EventFields event={event} />
          <div className="gallery">
            {(event.images || []).map((image) => (
              <Img className="image" key={image.key} fixed={image.fixed} alt={event.title} />
            ))}
          </div>
        </div>
      ))}
    </Layout>
  )
}

export default EventsPage
